// @ts-ignore
import isPersonnumer from 'is-personnummer';
import { IntlProvider } from 'react-intl';
import { setLocale } from 'yup';
import * as Yup from 'yup';
import messages from '../../../i18n/base-en';

const getRegisterCustomerClubFieldsValidationSchema = (intlData: IntlProvider.Props) => {
  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();
  const { formatMessage } = intl;

  setLocale({
    mixed: {
      required: formatMessage(messages.required_valid_error)
    },
    string: {
      email: formatMessage(messages.email_valid_error)
    }
  });

  Yup.addMethod(Yup.string, 'isValidPersonnumer', function(message: string) {
    return this.test('isValidPersonnumer', message, (value: string) => isPersonnumer(value));
  });

  const registerCustomerClubFieldsSchema = Yup.object().shape({
    address1: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true })
      .required(),
    city: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true })
      .required(),
    country: Yup.string().required(),
    state: Yup.string().when('$isStateFieldMounted', {
      is: (isStateFieldMounted: boolean) => isStateFieldMounted,
      then: Yup.string().required(),
      otherwise: Yup.string(),
    }),
    phoneNumber: Yup.string()
      .matches(/^[^a-zA-Z]*$/, formatMessage(messages.phone_valid_error))
      .matches(/^.{6,}$/, { message: formatMessage(messages.min_length_error, { min: 6 }), excludeEmptyString: true })
      .required(),
    zipCode: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true })
      .required(),
    physicalStore: Yup.string().when('$isPhisicalStoreMounted', {
      is: (isPhisicalStoreMounted: boolean) => isPhisicalStoreMounted,
      then: Yup.string().required(),
      otherwise: Yup.string(),
    }),
    identityNumber: Yup.string().when('$isIdentityNumberMounted', {
      is: (isIdentityNumberMounted: boolean) => isIdentityNumberMounted,
      // @ts-ignore
      then: Yup.string().isValidPersonnumer(formatMessage(messages.personnummer_valid_error)).required(),
      otherwise: Yup.string(),
    }),
  });

  return Yup.object().shape({ register: registerCustomerClubFieldsSchema });

};

export default getRegisterCustomerClubFieldsValidationSchema;
